import { useCallback } from 'react';
import { getTranslatedItem } from '@/utils/language.utils';
import { useListAllCheckPoints } from './check-point.hooks';

export const useGetTranslatedCheckPoint = () => {
  const { data: checkPoints } = useListAllCheckPoints();

  const getTranslatedCheckPoint = useCallback(
    (checkPointId: string) => {
      const translatedCheckPoints = checkPoints?.data?.find(
        (checkPoint) => checkPoint?.id === checkPointId,
      )?.translatedCheckPoints;

      return getTranslatedItem(translatedCheckPoints);
    },
    [checkPoints],
  );

  return {
    getTranslatedCheckPoint,
  };
};
